// components/bid_calculator/Header.jsx
// Bid Calculator Header using StandardHeader

import React from 'react';
import { StandardHeader } from '../../common/StandardHeader';

export const BidCalculatorHeader = ({ 
  loading = false,
}) => {
  return (
    <StandardHeader
      title="Bid Calculator"
      subtitle="Create, manage, and save bid scenarios"
      loading={loading}
      // No date range controls needed
      // No refresh needed
      // No lastUpdated timestamp
    />
  );
};